import styled from 'styled-components';

const Absolute = styled.div<{
	width?: number;
	height?: number;
	top?: number;
	left?: number;
	right?: number;
	bottom?: number;
	stretchToBounds?: boolean;
}>`
	position: absolute;
	${(props) =>
		props.stretchToBounds
			? 'top: 0;'
			: typeof props.top !== 'undefined'
			? `top: ${props.top}mm;`
			: ''}
	${(props) =>
		props.stretchToBounds
			? 'right: 0;'
			: typeof props.right !== 'undefined'
			? `right: ${props.right}mm;`
			: ''}
	${(props) =>
		props.stretchToBounds
			? 'bottom: 0;'
			: typeof props.bottom !== 'undefined'
			? `bottom: ${props.bottom}mm;`
			: ''}
	${(props) =>
		props.stretchToBounds
			? 'left: 0;'
			: typeof props.left !== 'undefined'
			? `left: ${props.left}mm;`
			: ''}
	${(props) => (typeof props.width !== 'undefined' ? `width: ${props.width}mm;` : '')}
	${(props) => (typeof props.height !== 'undefined' ? `height: ${props.height}mm;` : '')}
`;

export default Absolute;
